export {default} from './Detail.connect';
